import { useMemo } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { useChecklistState } from 'state/hooks/setup-checklist.hook';

import { Progress } from 'components/ui/progress';

export const SetupChecklistHeader: React.FC = () => {
  const { isExpanded, toggleChecklistExpandedState, categories } =
    useChecklistState();

  const categoriesProgress = useMemo(() => {
    if (!categories) return 0;

    const completedCategories = categories?.filter(
      (category) => category.status === 'done'
    )?.length;

    return (completedCategories / categories?.length) * 100;
  }, [categories]);

  return (
    <div
      className="flex flex-col w-full p-6"
      onClick={() => toggleChecklistExpandedState()}
    >
      <FontAwesomeIcon
        icon={`fa-solid ${isExpanded ? 'fa-down-left-and-up-right-to-center' : 'fa-up-right-and-down-left-from-center'}`}
        className="self-end cursor-pointer text-sm"
        style={{ color: 'var(--base-muted-foreground)' }}
      />
      <div className="text-sm font-semibold leading-5 font-sans mb-3">
        {'Setup checklist guide'}
      </div>
      <Progress
        value={categoriesProgress}
        className="bg-base-secondary"
        indicatorClassName="bg-indigo-500"
      />
    </div>
  );
};
